module.exports = __webpack_public_path__ + "media/images/breakclub-mint/down-arrow-74b0eba8d37f649741b129af6899b2ce.svg";